/* eslint-disable */
import React from 'react'

import {
  arrayOf,
  bool,
  number,
  oneOfType,
  shape,
  string
} from 'prop-types'

import {
  AppsProvider,
  ConnectedPeopleProvider,
  NotSmallTopbar,
  NotSmallRoute,
  SmallTopbar,
  SmallRoute,
  DisplaySwitch,
  railsCsrfFetch,
} from '@planningcenter/topbar'

const shared = {
  style: {
    zIndex: 1000
  }
}

export class APITopbar extends React.Component {
  render() {
    const {
      appName,
      orgName,
      railsEnv: env,
      routes: incomingRoutes,
      userId,
      userAvatarPath,
      userName,
      ...nativeProps
    } = this.props

    return (
      <AppsProvider
        env={env}
        configuredFetch={railsCsrfFetch}
        userId={userId}
        render={(apps, appsActions) => (
          <ConnectedPeopleProvider
            env={env}
            configuredFetch={railsCsrfFetch}
            render={(
              connectedPeople,
              connectedPeopleActions
            ) => {
              const sharedProps = {
                appName,
                apps,
                connectedPeople,
                env,
                orgName,
                requestAppsFetch: appsActions.fetch,
                requestClearAppsCache: appsActions.remove,
                requestConnectedPeopleFetch: connectedPeopleActions.fetch,
                requestClearConnectedPeopleCache: connectedPeopleActions.remove,
                requestUnlinkConnectedPeople: connectedPeopleActions.unlink,
                requestSwitchConnectedPerson: connectedPeopleActions.switch,
                userAvatarPath,
                userName,
                ...shared
              }

              return (
                <DisplaySwitch
                  smallBreakpoints={["xs", "sm"]}
                  smallTopbar={() => (
                    <SmallTopbar
                      {...sharedProps}
                      {...nativeProps}
                      routes={incomingRoutes
                        .filter(item => item !== false)
                        .map(
                          ({
                            name,
                            path,
                            active,
                            ...routeNativeProps
                          }) => (
                            <SmallRoute
                              key={name}
                              href={path}
                              active={active}
                              {...routeNativeProps}
                            >
                              {name}
                            </SmallRoute>
                          )
                        )}
                    />
                  )}
                  notSmallTopbar={() => (
                    <NotSmallTopbar
                      {...sharedProps}
                      {...nativeProps}
                      linkToProfile={false}
                      routes={incomingRoutes
                        .filter(item => item !== false)
                        .map(
                          ({
                            name,
                            path,
                            active,
                            ...routeNativeProps
                          }) => (
                            <NotSmallRoute
                              key={name}
                              href={path}
                              active={active}
                              {...routeNativeProps}
                            >
                              {name}
                            </NotSmallRoute>
                          )
                        )}
                    />
                  )}
                />
              )
            }}
          />
        )}
      />
    )
  }
}
APITopbar.propTypes = {
  railsEnv: string.isRequired,
  appName: string.isRequired,
  orgName: string.isRequired,
  userId: number.isRequired,
  userAvatarPath: string.isRequired,
  userName: string.isRequired,
  routes: arrayOf(
    oneOfType([
      bool,
      shape({ name: string, path: string, active: bool })
    ])
  ).isRequired
}

export default APITopbar
